import type Button from "./Button";
import type Channel from "./Channel";
import type ConnectableObject from "./ConnectableObject";
import { ConnectionType } from "./Connection";
import { channelTypeInfo } from "./ChannelType";

/** Shared, read-only channel selection for the classic plan and C1 preview/commit. */
export function findUnusedButtonChannel(
  button: Button,
  partner: ConnectableObject,
  connectionType: ConnectionType = ConnectionType.Button,
): Channel | undefined {
  if (connectionType === ConnectionType.Channel || partner.isActorChannel
    || (partner.isConsumer && channelTypeInfo(partner.channelType).isSupply)) return;
  const sortedChannels = button.channelsSortedForDisplay({
    buttonChannels: true,
    actorChannels: false,
    statusChannels: false,
    logicChannels: false,
    environmentChannel: false,
    temperatureMeasurementChannel: false,
    channelWithoutKnxChannel: false,
    generalChannel: false,
    specialChannel: false,
    patchChannels: false,
    longPressChannels: false,
    manualChannel: false,
    unknownChannel: false,
    ignoreChannel: false,
  });
  return sortedChannels.find(channel => !channel.isDeleted && channel.connections.size === 0
    && !channelTypeInfo(channel.channelType).isStatusChannel
    && channel.isConnectable(connectionType, partner));
}
